<div class="modal fade show" role="dialog" tabindex="-1" style="display: block;">
    <div class="modal-dialog" role="document" style="min-width: 90vw; width: 100%;">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title"> New Profile </h5>
                <button class="close" (click)="closePopup()"><i class="fa fa-times" aria-hidden="true"></i></button>
            </div>
            <div class="modal-body">
                <div *ngIf="loader">
                    <div id="global-loader">
                        <img src="./assets/img/loaders/loader.svg" class="loader-img" alt="Loader">
                    </div>
                </div>
                <div class="d-flex justify-content-center">
                    <div class="row">
                        <div class="col-6" style="width: 150px;
                        text-align: right;">
                            <label>Profile Name: <sup
                                    style="color: red; font-weight: 600; font-size: 18px;">*</sup></label>
                        </div>
                        <div class="col-6" style="width: 200px; padding-left: 7px;">
                            <input type="text" [(ngModel)]="newRole" style="width: 167%" (keypress)="validateName($event);" (ngModelChange)="changeRoleName($event)"
                                class="form-control" placeholder="Enter Profile Name">
                                <span class="text-danger" *ngIf="error" style="display: block; width: 100%;">{{ error }}</span>
                        </div>
                    </div>
                 
                </div>
                <div class="d-flex justify-content-center mt-2">
                    <div class="row">
                        <div class="col-6" style="width: 264px;
                        text-align: right;">
                            <label>Copy from Existing Profile:<sup
                                    style="color: red; font-weight: 600; font-size: 18px;">*</sup></label>
                        </div>
                        <div class="col-6">
                            <ng-select [items]="usertypes" class="panel" style="width: 300px;" [searchable]="true" bindLabel="name" [appendTo]="'body'"
                                bindValue="id" placeholder="Select Profile" [(ngModel)]="user_profile"
                                (ngModelChange)="changeUserType($event);" required>
                            </ng-select>
                        </div>
                    </div>
                </div>
                <div class="card mt-2" style="zoom: 80%" *ngIf="roleRightsJson.length > 0">
                    <div class="card-header pr-5" style="height: 60px">
                        <div class="container-fluid" style="padding-right: 10px;padding-left: 12px;">
                            <div class="main-header-left float-end">
                                 <span class="mr-3"><input type="checkbox"
                                        style="width: 30px; height: 24px; position: relative; top: 6px"
                                        [checked]="roleVisibility" (change)="changeVisibility()">Visibility</span>
                                <span class="mr-3"><input type="checkbox"
                                        style="width: 30px; height: 24px; position: relative; top: 6px"
                                        [checked]="allRead" (change)="setOverAllReadCheckbox(!allRead)">Read
                                    All</span>
                                    <span><input
                                        style="width: 30px; height: 24px; position: relative; top: 6px" type="checkbox"
                                        [checked]="allWrite" (change)="setOverAllWriteCheckbox(!allWrite)">Write
                                    All</span>
                            </div>

                        </div>
                    </div>
                    <div class="card-body">

                        <p-accordion [activeIndex]="0">
                            <div *ngFor="let json of roleRightsJson; let jsonIndex = index">
                                <div class="row mb-3" *ngIf="!json.accordion">
                                    <div class="col-4  px-5" *ngFor="let right of json.data; let i=index">
                                        <div class="d-flex flex-wrap justify-content-between">
                                            <div class="p-1 pt-3">
                                                <h6>{{right.title}}</h6>
                                            </div>
                                            <div class="p-1 float-end">
                                                <span class="mr-3"><input type="checkbox"
                                                        style="width: 30px; height: 24px; position: relative; top: 6px"
                                                        [checked]="right.read"
                                                        (change)="setReadCheckbox(jsonIndex, i, !right.read)">Read</span><span><input
                                                        style="width: 30px; height: 24px; position: relative; top: 6px"
                                                        type="checkbox" [checked]="right.write"
                                                        (change)="setWriteCheckbox(jsonIndex, i,  !right.write)">Write</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <p-accordionTab *ngIf="json.accordion" [selected]="jsonIndex == 2"
                                    styleClass="bg-primary" header="{{json.block_name}}">
                                    <p-header class="w-100">
                                        <div class="d-flex flex-wrap w-100">
                                        <div class="col-9">
                                            <h5 class="mb-0">{{json.block_name}}</h5>
                                        </div>
                                    <div class="col-3 d-flex justify-content-end pr-4">
                                    <div class="ms-4">

                                        <span class="mr-3"><input type="checkbox" id="block-read"
                                                style="width: 30px; height: 24px; position: relative; top: 6px"
                                                [checked]="json?.read" (click)="onMouseClick($event)"
                                                (change)="setAllReadCheckbox(jsonIndex, !json?.read)">Read</span>
                                    </div>
                                    <div class="mr-3">
                                        <span><input id="block-write"
                                                style="width: 30px; height: 24px; position: relative; top: 6px"
                                                type="checkbox" [checked]="json?.write"
                                                (click)="onMouseClick1($event)"
                                                (change)="setAllWriteCheckbox(jsonIndex, !json?.write)">Write</span>
                                    </div>
                                </div>
                               
                                        </div>
                                    </p-header>
                                    <div class="row">
                                        <div class="col-4 px-5" *ngFor="let right of json.data; let i=index">
                                            <div class="d-flex flex-wrap justify-content-between">
                                                <div class="p-1 pt-3">
                                                    <h6>{{right.title}}</h6>
                                                </div>
                                                <div class="p-1 float-end">
                                                    <span class="mr-3"><input type="checkbox" [checked]="right.read"
                                                            (change)="setReadCheckbox(jsonIndex, i, !right.read)"
                                                            style="width: 30px; height: 24px; position: relative; top: 6px">Read</span><span><input
                                                            style="width: 30px; height: 24px; position: relative; top: 6px"
                                                            type="checkbox" [checked]="right.write"
                                                            (change)="setWriteCheckbox(jsonIndex, i, !right.write)">Write</span>
                                                            <button 
                                                            class="btn btn-sm btn-primary ml-2" 
                                                            data-bs-toggle="modal" 
                                                            data-bs-target="#copyActionModal"
                                                            (click)="onCopyActionButtonClick(jsonIndex, i, copyActionModal)">
                                                            <i class="fas fa-cogs"></i>
                                                        </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </p-accordionTab>
                            </div>
                        </p-accordion>
                        
                    </div>
                </div>

            </div>
            <div class="modal-footer">
          <button class="btn btn-danger" (click)="closePopup()">Cancel</button>
          <button class="btn btn-primary" color="primary" (click)="submit()"
            [disabled]="buttonDisabled "> Save
          </button>
        </div>
        </div>
    </div>
</div>

<ng-template #copyActionModal let-modal>
    <div class="modal-header">
        <h5 class="modal-title">{{selectedTitle}} - Actions</h5>
        <button type="button" class="btn-close" (click)="modal.close()" aria-label="Close"></button>
    </div>
    <div class="modal-body">
        <div *ngIf="selectedActions && selectedActions.length > 0; else noActions">
            <div class="d-flex flex-wrap justify-content-between" *ngFor="let action of selectedActions; let index = index">
                <div class="pl-0 pr-1 pt-3">
                    <h6>{{ action.title }}</h6>
                </div>
                <div class="p-1 float-end d-flex align-items-center">
                    <span class="mr-3 color_theme">
                        <input 
                            type="checkbox" 
                            class="custom-checkbox" 
                            id="readCheckbox{{ index }}" 
                            [checked]="action.read" 
                            (change)="onReadCheckboxChange(index, $event)"
                            style="width: 30px; height: 24px; position: relative; top: 6px"> 
                    </span>
                </div>
            </div>
        </div>
        <ng-template #noActions>
            <p>No actions available.</p>
        </ng-template>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-danger" (click)="modal.close()">Close</button>
    </div>
</ng-template>

  
  